import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { ISecurityQuestionProps } from "./module/constants";

import { FormControl, TextField } from "@mui/material";
import { FormattedMessage } from "react-intl";

import classes from "./SecurityQuestion.module.scss";

import messages from "./module/messages";
import Panel from "../../ui/Panel/Panel";
import { selectQuestions } from "../../common/ProfileMgmtUtils/SecurityQuestionsSelector";
import { dispatchChangePwdAnswer } from "../../pages/ChangePassword/module/actions";

const SecurityQuestionChangePwd = (props: ISecurityQuestionProps) => {
  const {
    securityQuestionBody,
    securityQuestionKey,
    isSystemQuestion,
    index,
    setAnswerValueProp,
    questions,
    dropDown,
  } = props;

  const [questionValue, setQuestionValue] = useState("");
  const [answerValue, setAnswerValue] = useState("");

  // initialization
  useEffect(() => {
    setAnswerValueProp("", index);
  }, []);

  useEffect(() => {
    const retQ = questions[index].securityQuestion;
    if (retQ.includes("_")) {
      const mappedRetQ = retQ.split("_")[1];
      setQuestionValue(mappedRetQ);
    } else {
      setQuestionValue(retQ);
    }

    const retA = questions[index].answer ? questions[index].answer : "";
    setAnswerValue(retA);
  }, [questions]);

  const handleAnswerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;

    setAnswerValue(val);
    setAnswerValueProp(val, index);
  };

  return (
    <>
      <hr />
      <div className={classes["select-wrapper"]}>
        {/* question() */}

        <FormControl sx={{ flex: "8" }}>
          <label className={classes["label-form-control"]}>
            <FormattedMessage {...messages.securityQuestionLabelQuestion} />
          </label>
          <div style={{ marginBottom: "10px" }}>
            <Panel>
              <TextField
                variant="standard"
                fullWidth
                InputProps={{ readOnly: true }}
                key={"question" + securityQuestionKey}
                aria-label="textarea-comment"
                value={questionValue}
              />
            </Panel>
          </div>
        </FormControl>

        {/* answer() */}

        <FormControl sx={{ flex: "8" }} style={{ marginLeft: "25px" }}>
          <label className={classes["label-form-control"]}>
            <FormattedMessage {...messages.securityQuestionLabelAnswer} />
          </label>

          <div style={{ marginBottom: "10px" }}>
            <Panel>
              {
                <TextField
                  variant="standard"
                  fullWidth
                  InputProps={{ readOnly: false }}
                  key={"answer" + securityQuestionKey}
                  aria-label="textarea-comment"
                  value={answerValue}
                  onChange={handleAnswerChange}
                />
              }
            </Panel>
          </div>
        </FormControl>
      </div>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    questions: selectQuestions,
  });

/* DISPATCH ACTIONS */
const mapDispatchToProps: any = {
  setAnswerValueProp: (answer: string, questionId: number) =>
    dispatchChangePwdAnswer(answer, questionId),
};

//CONST CONNECT
const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(SecurityQuestionChangePwd);
